import { ProtocolAdapter } from './bacnet';

const REGISTER_TYPE_NAMES: Record<number, string> = {
  0: 'coil',
  1: 'input',
  2: 'hreg',
  3: 'ireg',
};

export const getModbusRegisterKey = (row: any): string | null => {
  if (!row || row.registerAddress == null) {
    return null;
  }
  const name = REGISTER_TYPE_NAMES[row.registerType];
  const suffix = row.bitNumber != null ? `#${row.bitNumber}` : '';
  return name ? `${name}:${row.registerAddress}${suffix}` : null;
};

export const formatModbusValue = (currentValue: any, config: any, systemEnum: any = null) => {
  if (config?.propertyMapping) {
    const { propertyMapping } = config;
    const universalKey = Object.keys(propertyMapping).find(
      (key) => String(propertyMapping[key]) === String(currentValue)
    );

    if (universalKey !== undefined && systemEnum?.[universalKey]) {
      return systemEnum[universalKey];
    }
  }

  const numValue = Number(currentValue);
  if (config?.customEnum?.[numValue]) {
    return config?.customEnum[numValue];
  }
  if (isNaN(numValue)) {
    return currentValue;
  }
  return Number.isInteger(numValue) ? String(numValue) : numValue.toFixed(1);
};

export const getModbusUniversalMappedPoints = (rowsOrData: any): Record<string, any> => {
  const rows: any[] = Array.isArray(rowsOrData)
    ? rowsOrData
    : rowsOrData?.rows || rowsOrData?.paramTemplateData?.rows || [];

  const mappedPoints: Record<string, any> = {};
  rows.forEach((row) => {
    if (row?.property) {
      const key = getModbusRegisterKey(row);
      if (key) {
        mappedPoints[row.property] = {
          row,
          key,
          config: {
            propertyMapping: row.propertyMapping,
            customEnum: row.customEnum,
            minValue: row.minValue,
            maxValue: row.maxValue,
            step: row.step,
            units: row.units,
            readOnly: row.readOnly,
            uiType: row.uiType,
          },
          ...row,
        };
      }
    }
  });
  return mappedPoints;
};

export const getModbusOperationalValue = (
  propertyKey: string,
  universalMappedPoints: Record<string, any>,
  operationalData: Record<string, any>
) => {
  const point = universalMappedPoints[propertyKey];
  if (!point?.key) {
    return null;
  }
  return operationalData?.[point.key] ?? null;
};

export const prepareModbusValue = (_identifier: any, value: any) => {
  const num = Number(value);
  return isNaN(num) ? value : num;
};

export const modbusAdapter: ProtocolAdapter = {
  getUniversalMappedPoints: getModbusUniversalMappedPoints,
  getOperationalValue: getModbusOperationalValue,
  formatValue: formatModbusValue,
  buildPointKey: (row: any) => (typeof row === 'string' ? row : getModbusRegisterKey(row) || ''),
  prepareValue: prepareModbusValue,
};
